// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"245":"component---src-pages-index-tsx","453":"component---src-pages-404-tsx","970":"component---src-pages-about-tsx"}[chunkId] || chunkId) + "-" + {"245":"de6d94f7ee19e4b46dbb","453":"11e254a285c1b30ecbc3","454":"9cf426442cac0271abe9","970":"764338c056eff15ba89d"}[chunkId] + ".js";
};